/**
 * A user's login lifecycle (Zugangsstatus) — applies to every `pt_user` row
 * regardless of role. Successor to the deprecated `registrationMode` /
 * `isOnboarded` pair. State changes happen only via dedicated commands —
 * one writer per transition.
 *
 * - PRACTICE_MANAGED: exists in the practice's records, no Keycloak account,
 *   cannot log in. The creation default. Only patients ever rest here (walk-ins).
 * - INVITED: a Keycloak account has been provisioned and an invitation sent;
 *   registration not yet complete.
 * - REGISTERED: registration complete, can log in, Keycloak account linked.
 *
 * Paths differ by flow: an invited user goes PRACTICE_MANAGED → INVITED →
 * REGISTERED; a self-registering user (e.g. the first admin via a registration
 * link) is created directly as REGISTERED, skipping the earlier states.
 */
export var AccessStatus;
(function (AccessStatus) {
    AccessStatus["PRACTICE_MANAGED"] = "PRACTICE_MANAGED";
    AccessStatus["INVITED"] = "INVITED";
    AccessStatus["REGISTERED"] = "REGISTERED";
})(AccessStatus || (AccessStatus = {}));
//# sourceMappingURL=access-status.enum.js.map